/**
 * 判断权限
 * @param {Array} hasRoles
 * @param {Array} targetRoles
 * @returns {Boolean}
 */
export const hasPermission = function (hasRoles, targetRoles) {
  // 不是数组直接返回
  if (!Array.isArray(hasRoles) || !Array.isArray(targetRoles)) return false
  for (let i = 0; i < hasRoles.length; i++) {
    const element = hasRoles[i]
    // 如果在目标数组里
    if (targetRoles.includes(element)) {
      return true
    }
  }
  return false
}
